import { render, staticRenderFns } from "./ModelsForm.vue?vue&type=template&id=f6c4ff76&"
import script from "./ModelsForm.vue?vue&type=script&lang=js&"
export * from "./ModelsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports